import axios from "axios";

import _ from "lodash";
import {
    GET_ACTIVE_DEVICES,
    GET_DEVICE_CHANNELS,
    SET_DATA_ASPECT_DAY_TOTAL_RECORDS,
    SET_CHANNEL_LIST,
    SET_HISTORICAL_DEVICES,

    HISTORICAL_DEVICES_LOADING,
    DATA_QUALITY_LOADING,

    ACTIVE_DEVICE_LOADING,
    SET_ACTIVE_WELLS,

    SET_HISTORICAL_DATAVIEWER,
    RIG_WELL_DATA,

    LOGOUT_SUCCESS,
    SET_HISTORICAL_DATAVIEWER_HEADER,
    HISTORICAL_DATAVIEWER_LOADING,
    SET_DATA_QUALITY_TOTAL_RECORD,
    SET_DATA_QUALITY_TIME,
    SET_HISTORICAL_DATAVIEWER_TOTAL_ROWS,
    SET_HISTORICAL_DATAVIEWER_TOTAL_PAGES,
    SET_GET_LOG,
    SET_COOKIES,
    SET_CONFIGURAION_DATA,
    SET_GET_CONFIGURAION_DATA,
    SET_DATA_LOG_MNEMONIC,
    SET_DATA_CHANNEL_TEMPLATE,
    SET_DATA_ASPECT_TEMPLATE,
    SET_DATA_ASPECT_DAY_TEMPLATE,
    GET_CARD_DATA,
    SET_RAW_DATA,
    SET_RAW_TOTAL_RECORD,
    WELL_DATAPROVIDER_DATA,
    SET_DATE_DATAPROVIDER,
    GET_REPORT_FILTER_DATA,
    GET_REPORT_DATA,
    GET_COLOR_DATA,
    SET_AUDIT_LIST,
    GET_CARD_DATA_TOTALRECORD,
    GET_SYNC_LIST,
    GET_SYNC_ACTION,
    GET_SYNC_DOWNLOAD
} from "../constants/action-types";
// import { loadingOn, loadingOff } from "../utils";
import { errorMsg, successMsg } from "../errorMsg/ErrorMsg";
import { loadingOff, loadingOn } from "../utils";

// const port = 'http://veras-chevron.sigmastream.com:8081'
// const port = 'http://192.168.3.41:8081'
const port = 'http://192.168.1.128:8081'
// const port = 'http://192.168.2.103:8081'
// const port = 'http://192.168.2.132:8081' 

// ${getState().data.apiUrl.address}

export const getWellActiveDevice = (switchChange,pageSize,pageIndex) => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/dq/getTemplateRecords`, {
            headers: {
                'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                'Content-Type': "application/json",
            },
            params: {
                sessionUser: sessionStorage.getItem("username"),
                switchChange: switchChange,
                'pageSize':pageSize,
                'pageNumber':pageIndex,
            }
        }
    )
        .then(res => {
            dispatch(loadingOff())
            console.log('res', res)
            if(res.data.data.data.Result === "OK"){
                dispatch({
                    type: GET_CARD_DATA,
                    payload: res.data.data.data.data,
                });
                dispatch({
                    type: RIG_WELL_DATA,
                    payload: res.data.data.data.rigWell,
                });
                dispatch({
                    type: WELL_DATAPROVIDER_DATA,
                    payload: res.data.data.data.wellDataProvider,
                });
                dispatch({
                    type: SET_ACTIVE_WELLS,
                    payload: res.data.Rigs,
                });
                dispatch({
                    type: GET_CARD_DATA_TOTALRECORD,
                    payload: res.data.data.data.data.totalRecord,
                });
            }else{
            console.error("No data available");
            }

        })
        .catch(error => {
            dispatch(loadingOff())
            console.error(error);
        })
};


export const getDataQuality = (wellName, data_provider) => (dispatch, getState) => {
    axios.post(`${getState().data.apiUrl.address}/veras/dq/fetchWellRecords?well=${wellName}&dataProvider=${data_provider}`,
        {
            headers: {
                'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                'Content-Type': "application/json",
            }
        }
    )
        .then(res => {
            // dispatch(loadingOff())

            // if (res.data.data.Result === undefined) {
              
                dispatch({                   
                    type: SET_DATA_QUALITY_TOTAL_RECORD,
                    payload: res.data.data.data,
                });
                dispatch(loadingOff())

            //     if(Object.keys(res.data.data.data).length > 0) {
            //     dispatch({
            //         type: SET_DATA_CHANNEL_TEMPLATE,
            //         payload: {},
            //     });
            //     dispatch({
            //         type: SET_DATA_ASPECT_TEMPLATE,
            //         payload: {},
            //     });
            //     dispatch({
            //         type: SET_DATA_ASPECT_DAY_TEMPLATE,
            //         payload: [],
            //     });
            // }
            // } else {
            //     dispatch({
            //         type: SET_DATA_QUALITY_TOTAL_RECORD,
            //         payload: {},
            //     });
            // }
        })
        .catch(error => {
            dispatch(loadingOff())
            console.error(error);
        })
};

export const getLogMnemonic = (rig, well, data_provider) => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/dq/getLogRecord`,
        {
            params: {
                'rig': rig,
                'well': well,
                "dataProvider": data_provider,
                'authorization': sessionStorage.getItem("header"),
                'sessionUser': sessionStorage.getItem('username')
            }
        }
    )
        .then(res => {
            dispatch({
                type: SET_DATA_LOG_MNEMONIC,
                payload: res.data.Message,
            });

        })
        .catch(error => {
            console.error(error);
        })
};

export const getDateDataprovider = (well) => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/dq/fetchDPDateRecords`,
        {
            params: {
                'well': well,
                "dataProvider": "all",
                'authorization': sessionStorage.getItem("header"),
                'sessionUser': sessionStorage.getItem('username')
            }
        }
    )
        .then(res => {
            // if(res.data.data.data.Result === "OK"){
                dispatch(loadingOff())
                dispatch({
                    type: SET_DATE_DATAPROVIDER,
                    payload: res.data.data.data.data,
                });
            // }
        })
        .catch(error => {
            dispatch(loadingOff())
            console.error(error);
        })
};


export const getChannelTemplate = (rig, well, data_provider, date, log, channel, pageSize, pageIndex) => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/dq/getChannelTemplateRecords`,
        {
            params: {
                'rig': rig,
                'well': well,
                "dataProvider": data_provider,
                'date': date,
                'channel': channel,
                'log': log,
                'pageSize':pageSize,
                'pageNumber':pageIndex,
                'authorization': sessionStorage.getItem("header"),
                'sessionUser': sessionStorage.getItem('username')
            }
        }
    )
        .then(res => {
            dispatch(loadingOff())
            dispatch({
                type: SET_DATA_CHANNEL_TEMPLATE,
                payload: res.data.data.data,
            });
            dispatch({
                type: SET_DATA_ASPECT_TEMPLATE,
                payload: res.data.data.data.aspect,
            });
            dispatch({
                type: SET_DATA_ASPECT_DAY_TEMPLATE,
                payload: res.data.data.data.processData,
            });
            dispatch({
                type: SET_DATA_ASPECT_DAY_TOTAL_RECORDS,
                payload: res.data.data.data.totalRecord,
            });

        })
        .catch(error => {
            dispatch(loadingOff())
            console.error(error);
        })
};

export const getRawData = (rig, well, data_provider, log, channel, startPoint, endPoint, pageSize, pageIndex) => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/dq/getChannelRAWRecords`,
        {
            params: {
                'rig': rig,
                'well': well,
                "dataProvider": data_provider,
                'log':log,
                'channel':channel,
                'startPoint':startPoint,
                'endPoint':endPoint,
                'pageSize': pageSize,
                'currentPage': pageIndex,
                'authorization': sessionStorage.getItem("header"),
                'sessionUser': sessionStorage.getItem('username')
            }
        }
    )
        .then(res => {

            dispatch({
                type: SET_RAW_DATA,
                payload: res.data.data.data,
            });
            dispatch({
                type: SET_RAW_TOTAL_RECORD,
                payload: res.data.data.data.totalRecords,
            });


        })
        .catch(error => {
            console.error(error);
        })
};

export const getChannelList = (feedId, url) => (dispatch) => {
    axios.get(`${url}:7095/yhrest/channel/list/${feedId}?startIndex=0&pageSize=1000&sorting=channel_id ASC`,
        {
            headers: {
                'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                'Content-Type': "application/json",
            }
        }
    )
        .then(res => {
            dispatch({
                type: SET_CHANNEL_LIST,
                payload: res.data.data,
            });

        })
        .catch(error => {
            console.error(error);
        })
};

export const gethistoricalDataViewer = (url, data, deviceType) => (dispatch) => {
    dispatch({
        type: HISTORICAL_DATAVIEWER_LOADING,
        payload: true,
    });

    var json = {
        "clientId": "RigAdmin",
        "apiKey": "8476509c72164674802e5471f3591435",
        "indexType": deviceType,
        "PARAMS": data
    }
    axios.post(`${url}:7095/yhrest/historical/get/DQData/`, json,
        {
            headers: {
                'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                'Content-Type': 'application/json',
            }
        }
    )
        .then(res => {
            const headerData = res.data.DATA.PAGE["header"].slice(0, 2);
            const totalRows = res.data.DATA["PARAMS"]["TOTALROWS"];
            const totalPages = res.data.DATA["PARAMS"]["TOTALPAGE"];


            dispatch({
                type: SET_HISTORICAL_DATAVIEWER,
                payload: res.data.DATA.PAGE["rows"].map((channelVal) => {
                    const tempObj = {};

                    channelVal.forEach((val, index) => {
                        if (headerData[index] === "timestamp") {
                            const timestamp = parseFloat(val);
                            const date = new Date(timestamp);
                            if (!isNaN(date)) {
                                const formattedDatetime = date.toISOString().slice(0, 19);
                                tempObj[headerData[index]] = `${formattedDatetime} GMT+00:00`;
                            } else {

                                tempObj[headerData[index]] = "Invalid Timestamp";
                            }
                        } else {
                            tempObj[headerData[index]] = val;
                        }
                    });

                    return tempObj;
                }),
            });



            dispatch({
                type: SET_HISTORICAL_DATAVIEWER_HEADER,
                payload: headerData,
            });
            dispatch({
                type: SET_HISTORICAL_DATAVIEWER_TOTAL_ROWS,
                payload: totalRows,
            });
            dispatch({
                type: SET_HISTORICAL_DATAVIEWER_TOTAL_PAGES,
                payload: totalPages,
            });


        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {

            dispatch({
                type: HISTORICAL_DATAVIEWER_LOADING,
                payload: false,
            });


        });
};


export const getLogData = (asset_id, url) => (dispatch) => {
    axios.get(`http://192.168.3.41:7095/yhrest/device/list?asset=${asset_id}`,
        {
            headers: {
                'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                'Content-Type': "application/json",
            }
        }
    )
        .then(res => {
            dispatch({
                type: SET_GET_LOG,
                payload: res.data.data,
            });


        })
        .catch(error => {
            console.error(error);
        })
};

export const configurationData = (url, feedID, json) => (dispatch) => {

    const data = new URLSearchParams();
    data.append('feedID', feedID);
    data.append('response-format', JSON.stringify(json));


    axios.post(`http://192.168.3.41:7095/yhrest/dq/updateConfiguration/`, data, {
        headers: {
            'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
            'Content-Type': "application/x-www-form-urlencoded",
        }
    })
        .then(res => {
            dispatch({
                type: SET_CONFIGURAION_DATA,
                payload: res
            })
        })
        .catch(error => {
            console.error(error);
        })
}

export const getConfigurationData = (url, feedID) => (dispatch) => {
    axios.get(`http://192.168.3.41:7095/yhrest/dq/getConfiguration?feedID=${feedID}`, {
        headers: {
            'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU='
        }
    })
        .then(res => {
            dispatch({
                type: SET_GET_CONFIGURAION_DATA,
                payload: res.data.data.Data
            })
        })
        .catch(error => {
            console.error(error);
        })
}

export const getReportFilterData = (getWellbore) => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/report/fetchRecords?authorization=${sessionStorage.getItem("header")}&sessionUser=${sessionStorage.getItem('username')}`, 
    {
        params: getWellbore ? {
            authorization: sessionStorage.getItem("header"),
            sessionUser: sessionStorage.getItem('username'),
            wellBore: "get"
        } : {
            authorization: sessionStorage.getItem("header"),
            sessionUser: sessionStorage.getItem('username')
        }
    })
        .then(res => {
            dispatch(loadingOff())
            dispatch({
                type: GET_REPORT_FILTER_DATA,
                payload: res.data.data.data
            })
            dispatch({
                type: GET_COLOR_DATA,
                payload: res.data.data.data.thresholdColors
            })
        })
        .catch(error => {
            dispatch(loadingOff())
            console.error(error);
        })
}

export const getReportData = (reportType, bUnit, dataProvider, rig, well, log, mnemonic, logType, startIndex, endIndex, switchErrorValue) => (dispatch, getState) => {
    axios.post(`${getState().data.apiUrl.address}/veras/report/fetchFilterRecords?authorization=${sessionStorage.getItem("header")}&sessionUser=${sessionStorage.getItem('username')}`,
    {
        "bUnit": bUnit,
        "reportType": reportType, // summary  ||  detailed  ||  config
        "indexType": logType,
        "dataProvider": dataProvider,
        "log": log,
        "rig": rig,
        "range": "all",
        "well": well,
        "mnemonic": mnemonic,
        "startPoint": startIndex,
        "endPoint": endIndex,
        "errorValue": switchErrorValue
    }
)
    .then(res => {
        dispatch(loadingOff())
        if(res.data.data.Result === 'ERROR' ){
            dispatch({
                type: GET_REPORT_DATA,
                payload: {data: {businessUnit: []}},
            });
            errorMsg(`Unable to Fetch ${reportType} Report`);
        }else{
            dispatch({
                type: GET_REPORT_DATA,
                payload: res.data.data.data,
            });
        }
        
    })
    .catch(error => {
        dispatch(loadingOff())

        console.error(error);
    })
};



export const getAuditList = (pageSize,pageIndex, startDate, endDate) => (dispatch,getState) => {
    axios.get( `${getState().data.apiUrl.address}/veras/audit/get`, 
    {
        params:{
            pageNumber: pageIndex,
            pageSize: pageSize,
            sortOrder: "",
            startTime: startDate? startDate : 0,
            endTime: endDate ? endDate : 0,
            columnName:"",
            columnValue:"",
            sessionUser: sessionStorage.getItem("username")
        },
            headers: {
                'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                'Content-Type': "application/json",
            }
        }
    )
        .then(res => {
            dispatch({
                type: SET_AUDIT_LIST,
                payload: res.data.data.data,
            });

        })
        .catch(error => {
            console.error(error);
        })
};

export const setSyncService = (EndPoint) => (dispatch, getState) => {
    axios
        .post(
            `${getState().data.apiUrl.address}/veras/sync/set`,

            EndPoint.endPointType === 'YellowHammer' ? {
                rig: EndPoint.rig,
                well: EndPoint.well,
                dataProvider: EndPoint.dataProvider,
                endPointType: EndPoint.endPointType,
                host: EndPoint.host,
                port: EndPoint.port,
                clientId: EndPoint.clientId,
                apiKey: EndPoint.apiKey,
                isSecure: EndPoint.isSecure,

            } : {
                rig: EndPoint.rig,
                well: EndPoint.well,
                dataProvider: EndPoint.dataProvider,
                endPointType: EndPoint.endPointType,
                url: EndPoint.url,
                userName: EndPoint.userName,
                password: EndPoint.password,
                version: EndPoint.version,
                dateFormat: EndPoint.dateFormat,
            },
            {
                headers: {
                    Authorization:
                        "Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=",
                    "Content-Type": "application/json",
                },
            }
        )
        .then((res) => {
            if (res.data.data.Result == "OK") {
                successMsg("Successfully requeste submitted!!!");
            } else {
                errorMsg(res.data.Msg)
            }
        })
        .catch((error) => {
            console.error(error);
        });
};


export const getSyncService = (pageSize, pageIndex, searchQuery, iconName, columnName) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/sync/list`,
            {
                params: {
                    "pageNumber": pageIndex,
                    "pageSize": pageSize,
                    "searchKey": searchQuery,
                    "sortingKey": columnName,
                    "sortingType": iconName
                },
                headers: {
                    'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                    'Content-Type': "application/json",
                }
            }
        )
        .then(res => {
            dispatch({
                type: GET_SYNC_LIST,
                payload: res,
            });

        })
        .catch((error) => {
            console.error(error);
        });
};


export const actionSyncService = (actionType, row) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/sync/actionType`,
            {
                params: {
                    "actionType": actionType,
                    "id": row?.id,
                },
                headers: {
                    'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                    'Content-Type': "application/json",
                }
            }
        )
        .then(res => {
            dispatch({
                type: GET_SYNC_ACTION,
                payload: res,
            });

        })
        .catch((error) => {
            console.error(error);
        });
};


export const downloadSyncService = (row) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/sync/download`,
            {
                params: {
                    "jobData": row,
                },
                headers: {
                    'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
                    'Content-Type': "application/json",
                }
            }
        )
        .then(res => {

            const contentLength = res.headers['content-length'];
            if (contentLength > 0) {
                const blob = new Blob([res.data], { type: "application/octet-stream" });
                const downloadUrl = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = "Folder.zip";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                // dispatch({
                //     type: GET_SYNC_DOWNLOAD,
                //     payload: res,
                // });
            } else {
                errorMsg("Log is not available.", "Download Error");
            }

        })
        .catch((error) => {
            console.error(error);
        });
};

